<template>
  <header></header>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      message: 'Campus <strong>Map</strong>'
    }
  },
  mounted () {
    this.$root.$on('set-header', (header) => {
      this.setHeader(header)
    })
  },
  methods: {
    setHeader (header) {
      this.message = header
    }
  }
}
</script>
